export const UPDATE_SEARCHLIST = 'backgroundcheckSearch/updateResults'

export const RESET_FILTERS = 'backgroundcheckSearch/reset'
export const RESET_RESULTS = 'backgroundcheckSearch/resetTableData'

export const UPDATE_CONTROL_NO = 'backgroundcheckSearch/getControlNo'
export const GET_DETAIL = 'backgroundcheckSearch/getDetails'

export const SET_CONFIRM_MODAL = 'backgroundcheckSearch/setConfirmModal'
export const HIDE_CONFIRM_MODAL = 'backgroundcheckSearch/hideConfirmModal'
export const SHOW_CONFIRM_MODAL = 'backgroundcheckSearch/showConfirmModal'

export const SET_CHANGE_APPROVER_MODAL = 'backgroundcheckSearch/setChangeApproverModal'
export const HIDE_CHANGE_APPROVER_MODAL = 'backgroundcheckSearch/hideChangeApproverModal'
export const SHOW_CHANGE_APPROVER_MODAL = 'backgroundcheckSearch/showChangeApproverModal'

// SEARCH FILTER TYPES
export const APPLY_FILTERS = 'backgroundcheckSearch/applySearchFilter'
export const CHG_FILTER_DATA = 'backgroundcheckSearch/changeFilterField'
export const CHG_FILTER_PAGE = 'backgroundcheckSearch/changePage'
export const CHG_FILTER_PAGE_SIZE = 'backgroundcheckSearch/changePageSize'
export const CHG_FILTER_SORT = 'backgroundcheckSearch/changeSortModel'
export const IS_LOADING = 'backgroundcheckSearch/isLoading'
export const CHG_SELECTED_ROWS = 'backgroundcheckSearch/changeSelected'
export const HIDE_LIST_ALERT = 'backgroundcheckSearch/hideAlert'
export const SET_LIST_ALERT = 'backgroundcheckSearch/setAlertModal'

// ADD FORM TYPES
export const CHG_FIELD = 'backgroundcheckAdd/changeField'
export const CHG_STATUS = 'backgroundcheckAdd/changeStatus'
export const CHG_EMPLOYEE_ID = 'backgroundcheckAdd/changeEmployeeId'
export const CHG_INCOME_ID = 'backgroundcheckAdd/changeIncomeId'
export const CHG_AMOUNT = 'backgroundcheckAdd/changeAmount'
export const CHG_EFFECTIVE_DATE = 'backgroundcheckAdd/changeEffectiveData'
export const CHG_MEMO = 'backgroundcheckAdd/changememo'
export const RESET_ADD_DATA = 'backgroundcheckAdd/resetAddData'
export const UPD_ADD_ALERT = 'backgroundcheckAdd/updateAlert'
export const HIDE_ADD_ALERT = 'backgroundcheckAdd/hideAlert'
export const UPD_ADD_MEMO_CHAR_COUNT = 'backgroundcheckAdd/updateMemoCharCount'
export const INSERT_LOADING = 'backgroundcheckAdd/isLoading'
export const SET_ADD_DATA = 'backgroundcheckAdd/setAddData'


// DETAIL FORM TYPES
export const UPD_DETAIL_TITLE = 'backgroundcheckDetail/changeTitle'
export const CHG_DETAIL_DATA = 'backgroundcheckDetail/changeFieldData'
export const UPD_DETAIL_MODE = 'backgroundcheckDetail/changeMode'
export const HAS_DETAIL_LOADED = 'backgroundcheckDetail/hasDetailLoaded'
export const SET_DETAIL_DATA = 'backgroundcheckDetail/setDetailData'
export const UPD_AMOUNT = 'backgroundcheckDetail/changeAmount'
export const HIDE_DETAIL_ALERT = 'backgroundcheckDetail/hideAlert'
export const UPD_DETAIL_MEMO_CHAR_COUNT = 'backgroundcheckDetail/updateMemoCharCount'
export const UPD_DETAIL_DATA = 'backgroundcheckDetail/updateDetailData'
export const SET_LOAN_LEDGER_DATA = 'backgroundcheckDetail/seterfLedgerData'
export const SHOW_LOAN_LEDGER = 'backgroundcheckDetail/showerfLedgerData'
export const HIDE_LOAN_LEDGER = 'backgroundcheckDetail/hideerfLedgerData'
export const SET_DETAIL_CONFIRM_MODAL = 'backgroundcheckDetail/setConfirmModal'
export const HIDE_DETAIL_CONFIRM_MODAL = 'backgroundcheckDetail/hideConfirmModal'
export const SHOW_DETAIL_CONFIRM_MODAL = 'backgroundcheckDetail/showConfirmModal'
export const SET_DETAIL_ALERT = 'backgroundcheckDetail/setAlertModal'
export const UPD_DETAIL_REMARKS = 'backgroundcheckDetail/changeRemarks'
export const UPDATE_CONFIRM_MODAL = 'backgroundcheckDetail/updateConfirmModal'
export const UPDATE_INITIAL_SUBMIT_STATE = 'backgroundcheckDetail/updateInitialSubmitState'
export const UPDATE_BACKGROUND_STATUS = 'backgroundcheckDetail/updateBackgroundStatus'
export const UPDATE_TEMPORARY_DISABLE = 'backgroundcheckDetail/updateTemporaryDisable'
export const SET_CHARACTER_REFERENCE_INITIAL_VALUES = 'backgroundcheckDetail/setCharacterReferenceInitialValues'
export const SET_STATUS_INITIAL_VALUES = 'backgroundcheckDetail/setStatusInitialValues'